// Mock adapter для dev режима
// Симулирует ответы сервера из локальных файлов

const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

// Импортируем mock-данные когда они будут
// import usersData from '../data/users.json';
// import productsData from '../data/products.json';

const mockAdapter = {
  async get(url, config = {}) {
    await delay(300); // имитация задержки сети

    // Пример маршрутов
    if (url === '/users') {
      return {
        data: [], // добавишь реальные mock-данные
        status: 200
      };
    }

    if (url === '/products') {
      return {
        data: [],
        status: 200
      };
    }

    // Если маршрут не найден
    return Promise.reject({
      status: 404,
      code: 'NOT_FOUND',
      message: `Mock endpoint not found: ${url}`
    });
  },

  async post(url, data, config = {}) {
    await delay(300);

    if (url === '/balance/getAll') {
      return {
        data: {
          success: true,
          data: [
            {
              id: 1,
              amount: 123.45,
              orderId: 12345,
              currency: 'USD',
              price: 123.45,
              date: '2024-06-01 12:00:00',
              status: 'created',
              payment_method: 'usdt',
              payment_url: 'https://example.com/pay/12345',
            },
            {
              id: 2,
              amount: 678.90,
              orderId: 12346,
              currency: 'USD',
              price: 678.90,
              payment_method: 'paypal',
              status: 'created',
              date: '2024-06-01 13:00:00',
              payment_url: 'https://example.com/pay/12345',
            }
          ],
          count: 2
        }
      };
    }

    if (url === '/order/getAll') {
      return {
        data: {
          success: true,
          data: [
            {
              id: 1,
              orderId: 12345,
              payment_method: 'usdt',
              price: 123.45,
              type: 'text',
              status: 'confirmed',
              date: '2024-06-01 12:00:00',
             
            },
            {
              id: 2,
              orderId: 12345,
              payment_method: 'usdt',
              price: 123.45,
              type: 'coin',
              status: 'created',
              date: '2024-06-01 12:00:00',
              product_id: 1,
              option_id: 2,
              game_id: '7_days_to_die_global',
              game_name: '7 Days to Die',
              option_name: 'Standard Edition',
              code: null,
            },

          ],
          count: 2
        }
      }
    }

    

 


    if (url === '/users/login') {

      return {
        data: {
          success: true,
          token: 'mock-jwt-token-12345',
          user: {
            id: 1,
            login: data.login,
            email: 'admin@example.com',
            timezone: 'Europe/London',
            balance: 0.00,
            user_id: '00123',
            free_download: 1
          }
        }
      };

      /* return Promise.reject({
         status: 400,
         code: 'USER_NOT_FOUNDED',
         message: 'A user with this login not found!'
       });
       */

    }

    if (url === '/users/registration') {
      return {
        data: {
          success: true,
          token: 'mock-jwt-token-12345',
          user: {
            id: 1,
            login: data.login,
            email: 'admin@example.com',
            timezone: 'Europe/London',
            balance: 0,
            user_id: '00123',
            free_download: 1
          }
        }
      };
    }

    if (url === '/auth/check') {
      return {
        data: {
          success: true,
          token: 'mock-jwt-token-12345',
          user: {
            id: 1,
            login: 'testuser',
            email: 'admin@example.com',
            timezone: 'Europe/London',
            balance: 0.00,
            user_id: '00123',
            free_download: 0
          }
        }
      };
    }

    if (url === '/users/info') {
      return {
        data: {
          data: {
            about: "Тест",
            birthDate: "2008-12-10",
            categories: ['design-web', 'design-socialmedia'],
            name: "John Doe",
            phone: "+7 (900) 000-00",
            telegramUsername: "@test"
          }

        }
      };
    }

    if (url === '/users/update-info') {
      return {
        data: {
          data: data
        }
      };
    }

 
    // Обработка POST запросов
    return {
      data: { success: true, ...data },
      status: 201
    };

  },




  async put(url, data, config = {}) {
    await delay(300);

    return {
      data: { success: true, ...data },
      status: 200
    };
  },

  async delete(url, config = {}) {
    await delay(300);

    return {
      data: { success: true },
      status: 200
    };
  }
};

export default mockAdapter;
